var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "minRowHeight", class: _vm.containerClasses },
    [
      _c(
        "div",
        { class: _vm.labelDivClass },
        [
          _vm._t("label", function () {
            return [
              _c(
                "span",
                {
                  staticClass: "flex text-label labelWidth leading-6",
                  class: [_vm.generalClasses, _vm.labelClasses],
                },
                [_vm._v(" " + _vm._s(_vm.formattedLabel) + " ")]
              ),
            ]
          }),
          _vm.showExtra
            ? _c(
                "span",
                {
                  staticClass: "text-label mr-auto",
                  class: _vm.generalClasses,
                },
                [
                  _c("span", { staticClass: "mr-2" }, [
                    _vm._v("(" + _vm._s(_vm.itemExtraInfo) + ")"),
                  ]),
                ]
              )
            : _vm._e(),
        ],
        2
      ),
      _vm._t(
        "default",
        function () {
          return [
            _c(
              "div",
              {
                class: [
                  _vm.contentContainerClass,
                  _vm.textClasses,
                  _vm.generalClasses,
                ],
              },
              [
                _c("p", { staticClass: "truncate" }, [
                  _vm._v(_vm._s(_vm.itemContent)),
                ]),
              ]
            ),
          ]
        },
        { textClasses: _vm.textClasses }
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }